import { enumify, Enumify } from '@mews/enumify';

function BaseDay() {}

const config = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
};
type Keys = keyof typeof config;
enumify<Keys, number>(BaseDay, 'Day', config);

export const Day = BaseDay as unknown as Enumify<Keys, number>;
